import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content" id="yui_3_17_2_1_1594796084625_34">
                    <div role="main" id="yui_3_17_2_1_1594796084625_33"><span id="maincontent"/>
                        <section id="yui_3_17_2_1_1594796084625_32">
                            <div className="" id="yui_3_17_2_1_1594796084625_31">
                                <div className="ilead-rgt task" id="yui_3_17_2_1_1594796084625_30">
                                    <div className="innerpadding" id="yui_3_17_2_1_1594796084625_29">
                                        <div className="innovativeimg" id="yui_3_17_2_1_1594796084625_28">
                                            <img alt=""
                                                 src={require('@images/How to deliver every time.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Aeroplanes are remarkable machines that can, depending on your
                                                view of the world, do wonderful
                                                things. But each aeroplane needs people to make it work.</p>


                                            <div className="border_subtitle">Deliver every time</div>
                                            <div className="paraspace"><p>In 1974, researchers Tversky and
                                                Kahneman<a className="superscripttext"
                                                           href="further_info.php?course=300"><sup>1</sup></a> described
                                                how an Israeli flight school decided to
                                                employ an interesting approach to try enhance trainee pilots’
                                                performance, to ensure perfect
                                                delivery of manoeuvres every time.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">To praise or not to praise?
                                                </div>
                                                <p>The instructors’ initial approach was to praise students when
                                                    they made excellent landings
                                                    and criticise when the landings were less smooth. However,
                                                    they soon noticed that the
                                                    performance of those students who had warranted praise would
                                                    nearly always decline on
                                                    their next attempt, whereas those who had received criticism
                                                    for particularly bad landings
                                                    almost always subsequently improved. The solution seemed
                                                    clear; criticism must be more
                                                    effective than praise in managing performance and ensuring
                                                    perfect delivery of manoeuvres.
                                                    Instructors, they suggested, should refrain from giving
                                                    praise and use criticism instead.</p>
                                                <div className="uiheading"><p>What the flight instructors didn’t
                                                    realise, however, is that they were witnessing a statistical
                                                    principle called ‘regression to the mean’; regardless of the
                                                    type of feedback a pilot received,
                                                    an outstanding performance can be expected to deteriorate at
                                                    the next attempt and a
                                                    terrible performance can be expected to improve. This is
                                                    because it’s difficult, perhaps
                                                    impossible, to maintain an extreme performance at either end
                                                    of the spectrum. At some
                                                    point the performance will move towards the average.</p>
                                                </div>
                                            </div>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>It seems that giving or receiving criticism is only one part of
                                                the puzzle to enhancing performance,
                                                and should be combined with other methods to help ensure
                                                delivery. This tool is all about<span
                                                    className="brown brownbold"> how to
         deliver every time</span> and will help you to consistently hit deadlines and provide quality pieces of work.
                                            </p>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}